import React, { Fragment } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import { Text } from 'components/Text';
import { useTranslation } from 'components/translation/TranslationProvider';
import './DealApproveModal.scss';
/**
 * @component DealApproveModal
 * @since 1.0.0
 * @hidden
 */
export function DealApproveModal(props) {
    const { onClose, onConfirm } = props;
    const { customLabels, language } = useTranslation();
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-approve-modal-button-container" },
            React.createElement(Button, { style: "primary", label: t('Yes'), onPress: onConfirm }))));
    return (React.createElement("div", { className: "deal-approve-modal" },
        React.createElement(Modal, { picto: "file-check", title: `${customLabels['Deal'][language]} ${t('Approve')}`, onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-approve-modal-content" },
                React.createElement(Text, { value: `${t('Are you sure to approve this')} ${customLabels['deal'][language]}?` })))));
}
